import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const token = localStorage.getItem('token');

window.Pusher = Pusher;

// derive API base from REACT_APP_API_URL or current origin
const API_BASE = 'https://www.alloaudit.com';

const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.REACT_APP_PUSHER_KEY,
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
  forceTLS: true,
  authEndpoint: `${API_BASE}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  },
});

export default echo;